import React from 'react';
import { IVideoDetail } from '../../../../models/Video.interface';

interface PlayerProps extends IVideoDetail {}

const VideoPlayer: React.FC<PlayerProps> = (props) => {
    // const category = props.category.id;
    const nowStyle = { 
        minWidth: '980px', 
        minHeight: '517px',
    };

    return (
        <div>
            <iframe
                src={props.url}
                allowFullScreen={true}
                title={props.video_name}  
                style={nowStyle}
            >
            </iframe>
        </div>
    );
};

export default VideoPlayer;